export const Marquee = () => {
  const items = [
    "SOURCING CHINE",
    "LIVRAISON DANS LE MONDE ENTIER",
    "ACHAT SÉCURISÉ",
    "SOURCING CORÉE",
    "B2B & B2C",
    "N'IMPORTE QUEL PAYS",
  ];
  const row = [...items, ...items];
  return (
    <div className="bg-brand-navy py-4 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="animate-marquee flex gap-8 items-center w-max">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-8">
            <span className="font-display font-semibold uppercase tracking-tight text-white/90 text-lg">
              {t}
            </span>
            <span className="text-brand-goldbright text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
